import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Map as ImmutableMap } from 'immutable';
import Availability from 'MeetingsBase/models/Availability';

function toMilliseconds(availability) {
  return availability.reduce(function (reduction, day, key) {
    return reduction.set(key, day.map(function (timeRange) {
      return timeRange.toMilliseconds();
    }));
  }, ImmutableMap());
}

var AvailabilityMilliseconds = /*#__PURE__*/function (_Availability) {
  _inherits(AvailabilityMilliseconds, _Availability);

  function AvailabilityMilliseconds() {
    _classCallCheck(this, AvailabilityMilliseconds);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMilliseconds).apply(this, arguments));
  }

  _createClass(AvailabilityMilliseconds, null, [{
    key: "from",
    value: function from(data) {
      if (!data || Object.keys(data).length === 0) {
        return new AvailabilityMilliseconds(_get(_getPrototypeOf(AvailabilityMilliseconds), "from", this).call(this, data));
      }

      return this.fromAvailability(Availability.from(data));
    }
  }, {
    key: "fromAvailability",
    value: function fromAvailability(availability) {
      /**
       * @param {Availability} availability Configured weekly availability
       * @returns {AvailabilityMilliseconds} Configured weekly availability, expressed in
       * millisecond timestamps
       */
      if (!availability || Object.keys(availability).length === 0) {
        return new AvailabilityMilliseconds();
      }

      var availabilityInMilliseconds = toMilliseconds(availability);
      return new AvailabilityMilliseconds(availabilityInMilliseconds);
    }
  }]);

  return AvailabilityMilliseconds;
}(Availability);

export { AvailabilityMilliseconds as default };